/* eslint-disable jsx-a11y/anchor-is-valid */
import {toAbsoluteUrl} from '../../../../_metronic/helpers/AssetHelpers'
import {CustomButton} from '../../widgets/components/UI/CustomButton'
import * as Yup from 'yup'
import {Formik, Form} from 'formik'
import TextInput from '../../widgets/components/Input/TextInput'
import {useIntl} from 'react-intl'
import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import TextArea from '../../widgets/components/Input/TextArea'
import {FileUpload} from '../../widgets/components/FileUpload'
import {useAuth} from '../../auth'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import '../../onboarding/styles/onboarding.scss'
import {toast} from 'react-toastify'

import {socialMediaType} from '../../profile/core/_models'
import {socialMediaData} from '../../profile/core/_constants'
import {Modal} from 'react-bootstrap'
import {updateCompanyProfile} from '../../profile/core/_requests'
import {SelectInput} from '../../widgets/components/Input/SelectInput'
import {getCountry} from '../../onboarding/core/_requests'
import {CountryModel} from '../../onboarding'
import {verifyToken} from '../../auth/core/_requests'
import {Spinner} from '../../widgets/components/General/Spinner'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

export function AddCompanyModal({
  showCompanyModal,
  setShowCompanyModal,
  companyImgName,
  setCompanyImgName,
  companyPageData,
  getCompanyPageData,
  companyApiLoading,
}: {
  showCompanyModal: boolean
  setShowCompanyModal: Dispatch<SetStateAction<boolean>>
  companyImgName: any
  setCompanyImgName: any
  companyPageData: any
  getCompanyPageData: any
  companyApiLoading: boolean
}) {
  const [loading, setLoading] = useState(false)
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const {companyId, currentUser, setCurrentUser} = useAuth()
  const {formatMessage} = useIntl()
  const [countryOptions, setcountryOptions] = useState<any[]>([])

  const companyInitialValues = {
    companyName: '',
    description: '',
    country: '',
    logoId: null,
    socialMedia: {
      website: '',
      facebook: '',
      twitter: '',
      linkedin: '',
      instagram: '',
    },
  }
  const companySchema = Yup.object().shape({
    companyName: Yup.string()
      .required(formatMessage({id: 'Company name is required'}))
      .min(3, formatMessage({id: 'Minimum 3 characters'}))
      .nullable(),
    description: Yup.string()
      .required(formatMessage({id: 'Description is required'}))
      .min(3, formatMessage({id: 'Minimum 3 characters'}))
      .nullable(),
    country: Yup.string()
      .required(formatMessage({id: 'Country is required'}))
      .nullable(),
    socialMedia: Yup.object().shape({
      website: Yup.string()
        .url(formatMessage({id: 'Please Enter the valid URL'}))
        .nullable(),
      facebook: Yup.string()
        .url(formatMessage({id: 'Please Enter the valid URL'}))
        .nullable(),
      twitter: Yup.string()
        .url(formatMessage({id: 'Please Enter the valid URL'}))
        .nullable(),
      linkedin: Yup.string()
        .url(formatMessage({id: 'Please Enter the valid URL'}))
        .nullable(),
      instagram: Yup.string()
        .url(formatMessage({id: 'Please Enter the valid URL'}))
        .nullable(),
    }),
  })

  useEffect(() => {
    const fetchCountry = async () => {
      const {
        data: {data: countries},
      } = await getCountry()
      const countriesData = countries.map((country: CountryModel) => {
        return {
          id: country.countryId,
          name: country.country_name,
          value: country.countryId,
        }
      })
      setcountryOptions([...countriesData])
    }
    fetchCountry()
  }, [])

  const onSubmit = async (values: any) => {
    const updateCompanyData = {
      name: values.companyName,
      description: values.description,
      countryId: values.country,
      logoId: values.logoId,
      website: values.socialMedia.website,
      facebook: values.socialMedia.facebook,
      twitter: values.socialMedia.twitter,
      linkedin: values.socialMedia.linkedin,
      instagram: values.socialMedia.instagram,
      companyId: companyId,
    }
    try {
      setLoading(true)
      const {
        data: {success, errors, data},
      } = await updateCompanyProfile(updateCompanyData)
      if (success) {
        setLoading(false)
        getCompanyPageData()
        setShowCompanyModal(false)
        toast.success(formatMessage({id: 'Company updated successfully'}))

        const {
          data: {success},
        } = await verifyToken(data.token)
        if (success) {
          setCurrentUser(currentUser)
        }
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdateCompanyProfileSuccessful,
            action: 'normal',
            metadata: removeNullFields({
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company: {
                name: values.companyName,
                description: values.description,
                country_id: values.country,
                logo_id: values.logoId,
                website: values.socialMedia.website,
                facebook: values.socialMedia.facebook,
                twitter: values.socialMedia.twitter,
                linkedin: values.socialMedia.linkedin,
                instagram: values.socialMedia.instagram,
                company_id: companyId,
              },
            }),
          },
        })
      } else {
        setLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdateCompanyProfileFailed,
            action: 'normal',
            metadata: removeNullFields({
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company: {
                name: values?.companyName,
                description: values?.description,
                country_id: values?.country,
                logo_id: values?.logoId,
                website: values?.socialMedia.website,
                facebook: values?.socialMedia.facebook,
                twitter: values?.socialMedia.twitter,
                linkedin: values?.socialMedia.linkedin,
                instagram: values?.socialMedia.instagram,
                company_id: companyId,
              },
              error: errors[0],
            }),
          },
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  return (
    <>
      <Modal
        size='lg'
        show={showCompanyModal}
        onHide={() => setShowCompanyModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        {companyApiLoading ? <Spinner /> : null}
        <Formik
          initialValues={companyInitialValues}
          validationSchema={companySchema}
          onSubmit={onSubmit}
        >
          {(formik) => {
            setCompanyImgName(companyPageData?.file?.name)
            formik.initialValues.companyName = companyPageData?.name
            formik.initialValues.description = companyPageData?.description
            formik.initialValues.country = companyPageData?.country
            formik.initialValues.logoId = companyPageData?.logoId
            formik.initialValues.socialMedia.website = companyPageData?.website
            formik.initialValues.socialMedia.facebook = companyPageData?.facebook
            formik.initialValues.socialMedia.twitter = companyPageData?.twitter
            formik.initialValues.socialMedia.linkedin = companyPageData?.linkedin
            formik.initialValues.socialMedia.instagram = companyPageData?.instagram
            formik.initialValues.country = companyPageData?.countryId
            return (
              <Form>
                <Modal.Body>
                  <div className='d-flex justify-content-between m-5'>
                    <h2>{formatMessage({id: 'Edit Company Details'})}</h2>
                    <img
                      src={toAbsoluteUrl('/media/icons/investor/Cancel.svg')}
                      alt={formatMessage({id: 'cancel'})}
                      className='cursor-pointer'
                      onClick={() => {
                        setShowCompanyModal(false)
                        setCompanyImgName('')
                      }}
                    />
                  </div>
                  <div className='mt-8 m-5'>
                    <div className=''>
                      <div className='d-flex'>
                        <div className='col-md-5 col-10'>
                          <p>{formatMessage({id: 'Profile Picture'})}</p>
                          <div
                            className={`people-profile-card position-relative d-flex justify-content-center m-md-0 m-auto ${
                              companyImgName ? 'card-name' : 'p-0'
                            }`}
                            onClick={handleOpen}
                          >
                            <DisplayImage
                              imgName={companyImgName}
                              alt={formatMessage({id: 'profile'})}
                              width='100%'
                            />
                            <div className='pencil-container'>
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                                alt=''
                                className='cursor-pointer'
                              />
                            </div>
                          </div>
                          <div className='mt-4 allowedType'>
                            {formatMessage({id: 'Allowed file types: png, jpg, jpeg.'})}
                          </div>
                        </div>
                        <FileUpload
                          fileSize={2097152}
                          maxFileNumber={1}
                          allowType={['image/*', '.jpg', '.jpeg', '.png']}
                          metaData={{module: 'logo', isProtected: false}}
                          modalStatus={modelStatus}
                          handleClose={handleClose}
                          handleSuccess={(id: number, name: string) => {
                            setCompanyImgName(name)
                            formik.setFieldValue('logoId', id)
                          }}
                          resourceType='all'
                        />
                        <div className='col-md-7 col-12 mt-md-0 mt-6'>
                          <TextInput
                            fieldType={'text'}
                            label={formatMessage({id: 'Company Name'})}
                            fieldName={'companyName'}
                            formik={formik}
                            placeholder={formatMessage({id: 'Enter the Company Name'})}
                            margin='me-6'
                            toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.COMPANY.COMPANY_NAME'})}
                            isStarRequired={true}
                          />
                          <SelectInput
                            label={formatMessage({id: 'Country'})}
                            fieldName={'country'}
                            placeholder={formatMessage({id: 'Select Your Country'})}
                            formik={formik}
                            toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.COMPANY.COUNTRY'})}
                            options={countryOptions}
                            margin={'me-6'}
                          />
                          <TextArea
                            fieldName={'description'}
                            formik={formik}
                            placeholder={formatMessage({
                              id: 'Short Description',
                            })}
                            label={formatMessage({id: 'Description'})}
                            toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.COMPANY.DESCRIPTION'})}
                            isStarRequired={true}
                          />
                        </div>
                      </div>
                      <div className='col-12 mt-md-3 p-md-0 p-5'>
                        <div className='fs-4 fw-bold mb-4'>
                          {formatMessage({id: 'Social Media'})}
                        </div>
                        {socialMediaData.map(
                          ({id, icon, iconLable, placeholder, fieldName}: socialMediaType) => (
                            <div className='d-flex mb-md-4 mb-2 gap-1' key={id}>
                              <div className='d-md-flex align-items-md-center me-md-3'>
                                <img
                                  src={toAbsoluteUrl(`/media/icons/duotune/social/${icon}`)}
                                  width='20px'
                                  height='20px'
                                  alt={iconLable}
                                />
                              </div>
                              <TextInput
                                fieldType={'url'}
                                fieldName={fieldName}
                                formik={formik}
                                placeholder={formatMessage({id: placeholder})}
                                label={formatMessage({id: iconLable})}
                                width={20}
                                isTooltipNotRequired={true}
                                isBeside={true}
                                labelWidth='w-125px'
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className='p-0'>
                  <button
                    type='button'
                    className='btn btn-light font-size-13 font-weight-400'
                    onClick={() => {
                      setShowCompanyModal(false)
                      setCompanyImgName('')
                    }}
                  >
                    {formatMessage({id: 'Cancel'})}
                  </button>
                  <CustomButton
                    isSubmitting={formik.isSubmitting}
                    isValid={formik.isValid}
                    buttonText={formatMessage({
                      id: 'Edit Company',
                    })}
                    loading={loading}
                    widthLoading={2}
                    width={2}
                    margin={'me-5 mt-5'}
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
